import React from 'react';
import PropTypes from 'prop-types';

import {oeInterfaceManager} from '../../../../react-oe/oe-interface';
import OEInterfaceAdapter from '../../../../react-oe/oe-interface-adapter';
import OEResizeObserver from '../../../../lib/components/oe-resize-observer';
import OEFNElement from '../../../elements/oe-flow-nav-elements';
import OEPlyr from '../../../elements/oe-plyr';

export class OEFNHelpVideos extends React.PureComponent {

    constructor(props) {
        super(props);

        this.oe = oeInterfaceManager.getInterface(this.props.moduleId);

        this.state = {
            videos: [],
            numColumn: 3
        };

        this.updateLanguage = this.updateLanguage.bind(this);

        this.onResize = this.onResize.bind(this);
    }

    componentWillReceiveProps(nextProps)   {
        if(nextProps.locStringPrefix !== this.props.locStringPrefix)  {
            this.updateLanguage(nextProps);
        }
    }

    onConnect()  {
        this.oe.sharedNotificationCenter.register(this.oe.NotificationName.languageChanged, this.updateLanguage);
    }

    onRelease()    {
        this.oe.sharedNotificationCenter.unregister(this.oe.NotificationName.languageChanged, this.updateLanguage);
    }

    updateLanguage(props)   {
        props = props || this.props;
        let si = this.oe.sharedInterface;
        let videos = [];
        for(let i = 1; i < 10; ++i) {
            videos.push(si.getLocalizedStringEnc(props.locStringPrefix + 'tutorial_video_' + i.toString() + '_youtube'));
        }

        this.setState({videos: videos});
    }

    updateState(released)   {
        if(!this.oe.isReady() || released === true)   {
            return;
        }

        this.updateLanguage();
    }

    onResize(sender, size)  {
        let numColumn = size.w > 600 ? 3 : (size.w > 400 ? 2 : 1);
        this.setState({numColumn: numColumn});
    }

    render() {
        let videos = this.state.videos.map((src, index) => <OEPlyr key={index} src={src}/>);

        let num = (Math.floor(videos.length / this.state.numColumn) + (videos.length % this.state.numColumn > 0 ? 1 : 0)) * this.state.numColumn;
        let videoElements = [];

        /*
        let numRows = num / this.state.numColumn;
        for(let row = 0; row < numRows; ++row)  {
            let videoRow = [];

            for(let column = 0; column < this.state.numColumn; ++column)    {
                let i = row * this.state.numColumn + column;
                videoRow.push(
                    <div key={i} className="video-item">
                        {i < videos.length ? videos[i] : null}
                    </div>
                );
            }

            videoElements.push(
                <div key={row} className="video-container">
                    {videoRow}
                </div>
            );
        }
        */

        let style = {width: (90 / this.state.numColumn).toString() + '%'};

        for(let i = 0; i < num; ++i)    {
            videoElements.push(
                <div key={i} className="video-item" style={style}>
                    {i < videos.length ? videos[i] : null}
                 </div>
            );
        }

        return (
            <React.Fragment>
                <OEInterfaceAdapter moduleId={this.props.moduleId} receiver={this}/>
                <OEFNElement.View className="video help-videos">
                    <OEResizeObserver onResize={this.onResize}/>
                    {/*videoElements*/}
                    <div className="video-container">
                        {videoElements}
                    </div>
                </OEFNElement.View>
            </React.Fragment>
        );
    }
}

OEFNHelpVideos.defaultProps = {
    moduleId:           '',
    locStringPrefix:    ''
};

OEFNHelpVideos.propTypes = {
    moduleId:           PropTypes.string,
    locStringPrefix:    PropTypes.string
};